import React, { useEffect } from "react";
import "./DashboardStatistics.scss";
import SideBarModule from "../../components/sidebarComponents/SideBarModule";
import { useDispatch } from "react-redux";
import { setInitialTableContent } from "../../store/actions/statisticsTable";
import DashboardStatisticsRightContent from "../../components/DashboardStatisticRightContent";

const DashboardStatistics = () => {
  const dispatch = useDispatch()

  useEffect(() => {
        dispatch(setInitialTableContent())
  }, [dispatch])

  return (
    <div className={"dashboard-statistics"}>
      <SideBarModule />
      <DashboardStatisticsRightContent/>
    </div>
  );
};

export default DashboardStatistics;

